"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types = {
    PaymentsService: Symbol.for("PaymentsService"),
    ChangelogRecorder: Symbol.for("ChangelogRecorder"),
    FalconConvenienceApiService: Symbol.for("FalconConvenienceApiService"),
    CacheManager: Symbol.for("CacheManager")
};
exports.Types = Types;
//# sourceMappingURL=Types.js.map